import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxStaff from '../util/remote/ajaxStaff';

const initialState = { 
    metaData: null,
    currentPage: 1,
    listing: null,
    mounted: false,
    profileInfo: null, 
    staffId: null,
    prefixes: null,
    totalStaff: null,
    staffSubjects: null,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const StaffContext = createContext();

export const StaffProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
 
   /**
   * Only call this if the getTransactions has already been called on mount by the AccountStatementPage
   */
  useEffect(()=>{
    if(state.mounted){
      getStaffMembers();
    }
  }, [state.currentPage])


  const getStaffMembers = async (refresh = false) => {
    dispatch({ type: "mounted", payload: true });

    if (refresh) {
            dispatch({ type: "listing", payload: null });
            dispatch({ type: "metaData", payload: null });
            setCurrentPage(1);
        }
    
        const server_response = await ajaxStaff.getStaff({
            page: refresh ? 1 : state.currentPage,
        });
    
        if (server_response.status === "OK") {
            const newTransactions = server_response.details.data;
    
            dispatch({
                type: "listing",
                payload: refresh ? newTransactions
                        : state.listing
                        ? [...state.listing, ...newTransactions]
                        : newTransactions
            });
    
            dispatch({ type: "metaData", payload: server_response.details.meta });
        } else {
            dispatch({ type: "listing", payload: "404" });
            dispatch({ type: "metaData", payload: "404" });
        }
    
  };

 const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
 }

const getPrefixes = async () => {
    if (state.prefixes) return;
    const server_response = await ajaxStaff.fetchPrefixes();
    if (server_response.status === 'OK') {
        dispatch({ type: 'prefixes', payload: server_response.details });
    }
    else {
        dispatch({ type: 'prefixes', payload: '404' });
    }
};
  

const getTotalStaff = async () => {
    const server_response = await ajaxStaff.getStaffPopulation();
    if (server_response.status === 'OK') {
        dispatch({ type: 'totalStaff', payload: server_response.details });
    }
}

  const loadProfile = async (staffId) => {
    dispatch({ type: 'staffId', payload: staffId });
    dispatch({ type: 'profileInfo', payload: null });

    const server_response = await ajaxStaff.fetchStaffInfo(staffId);
    if (server_response.status === "OK") {
        dispatch({ type: 'profileInfo', payload: server_response.details });
    } else {
        dispatch({ type: 'profileInfo', payload: "404" });
    }
    await getStaffSubjects(staffId);
  };

  const getStaffSubjects = async (staffId) => {
    dispatch({ type: 'staffSubjects', payload: null });
    const server_response = await ajaxStaff.fetchStaffSubjects(staffId);
    if (server_response.status === "OK") {
        dispatch({ type: 'staffSubjects', payload: server_response.details });
    }
    else {
        dispatch({ type: 'staffSubjects', payload: "404" });
    }
  }
  


  return(
    <StaffContext.Provider value={{
      ...state,
      dispatch,
      getStaffMembers,
      getPrefixes,
      getTotalStaff,
      loadProfile,
      setCurrentPage,
      }}>
      {children}
    </StaffContext.Provider>
  )

}

export const useStaff = ()=>useContext(StaffContext);

